export default __webpack_public_path__ + "static/media/account-bg.3b0e6b79.png";